import { ServiceCompany } from "../../Model/ServiceCompany/ServiceCompany";

export class GetServiceCompanyList {
    constructor(
        total,
        offset,
        limit,
        records
    ) {
        this.total = total;
        this.offset = offset;
        this.limit = limit;
        this.records = records;
    }
    static createFromResponseData(data) {
        return new GetServiceCompanyList(
            data.total,
            data.offset,
            data.limit,
            data.records.map((records) => {
                return ServiceCompany.createFormResponseData(records);
            }),
        );
    }
}